import React from 'react';

import RichText from '../../shared/components/richtext';

import '../css/product-overview.less';

const ProductOverview = ({ overview, className, richTextProps }) => {
    return (
        <div className={'product-overview' + (className ? ` ${className}` : '')}>
            <RichText text={overview} {...(richTextProps || {})} />
        </div>
    );
};

export default ProductOverview;
